type LookupRequest = { signal: AbortSignal; isCurrent: () => boolean };

export class OperatorWorkOrderRequestController {
  private lookupVersion = 0;
  private lookupController: AbortController | null = null;
  private lookupTimer: ReturnType<typeof setTimeout> | null = null;
  private starting = false;
  private outcomeUnknown = false;

  beginLookup(): LookupRequest {
    if (this.lookupTimer !== null) { clearTimeout(this.lookupTimer); this.lookupTimer = null; }
    this.lookupVersion += 1;
    this.lookupController?.abort();
    const version = this.lookupVersion;
    const controller = new AbortController();
    this.lookupController = controller;
    return { signal: controller.signal, isCurrent: () => this.lookupVersion === version && !controller.signal.aborted };
  }

  cancelLookup() {
    if (this.lookupTimer !== null) { clearTimeout(this.lookupTimer); this.lookupTimer = null; }
    this.lookupVersion += 1;
    this.lookupController?.abort();
  }

  scheduleLookup(callback: (request: LookupRequest) => void, delayMs = 350) {
    this.cancelLookup();
    this.lookupTimer = setTimeout(() => {
      this.lookupTimer = null;
      callback(this.beginLookup());
    }, delayMs);
  }

  beginStart() {
    if (this.starting || this.outcomeUnknown) return false;
    this.starting = true;
    return true;
  }

  finishStart() { this.starting = false; }
  markOutcomeUnknown() { this.outcomeUnknown = true; }
  resolveOutcome() { this.outcomeUnknown = false; }
  get startBlocked() { return this.starting || this.outcomeUnknown; }
}
